import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { PublicNav } from "@/components/layout/PublicNav";
import { Footer } from "@/components/layout/Footer";
import { Seo } from "@/components/seo/Seo";
import { MobileNavTabs } from "@/components/layout/MobileBottomNav";
import { LocalModeBar } from "@/components/local-mode/LocalModeBar";

const LOCAL_MODE_ROUTES = ["/chatter", "/people", "/businesses", "/capital", "/groups", "/events", "/resources"];

export default function PublicLayout() {
  const { pathname } = useLocation();
  // Bottom tab bar everywhere on mobile except the marketing landing page.
  const showBottomNav = pathname !== "/" && pathname !== "/home";
  const showLocalMode = LOCAL_MODE_ROUTES.includes(pathname);
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Seo />
      <PublicNav />
      {showBottomNav && <MobileNavTabs />}
      {showLocalMode && <LocalModeBar />}
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
